import { mapState } from "vuex";
import type { IState } from "@/store";
import type { ICountry } from "@/models/constants";

export default {
  data: () => ({
    countriesLoaded: false
  }),
  async created() {
    await this.getCountries();
    this.countriesLoaded = true;
  },
  computed: {
    ...mapState({
      countries: (state: IState) => state.constants.countries
    })
  },
  methods: {
    async getCountries() {
      return await this.$store.dispatch("constants/getCountries");
    },
    getCountryPropValue(countryId: ICountry["id"], propValue: string) {
      return this.$_.get(
        this.$_.find(this.countries, ["id", countryId]),
        propValue,
        ""
      );
    }
  }
};
